var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 318.155,
    height: 191.872,
    viewBox: "0 0 318.155 191.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dot",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-12",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-13",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-14",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 191.872) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-15",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-16",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-17",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-18",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-19",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-20",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-21",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-22",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-23",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-24",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-25",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-26",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-27",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-28",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 168.56) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-29",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-30",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-31",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-32",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-33",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-34",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-35",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-36",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-37",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-38",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-39",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-40",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-41",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-42",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 145.248) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-43",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-44",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-45",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-46",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-47",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-48",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-49",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-50",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-51",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-52",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-53",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-54",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-55",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-56",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 121.937) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-57",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-58",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-59",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-60",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-61",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-62",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-63",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-64",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-65",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-66",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-67",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-68",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-69",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-70",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 98.625) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-71",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-72",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-73",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-74",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-75",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-76",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-77",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-78",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-79",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-80",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-81",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-82",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-83",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-84",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 75.314) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-85",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-86",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-87",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-88",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-89",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-90",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-91",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-92",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-93",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-94",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-95",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-96",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-97",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-98",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 52.002) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-99",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-100",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-101",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-102",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-103",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-104",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-105",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-106",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-107",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-108",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-109",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-110",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-111",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-112",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 28.692) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-113",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(0 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-114",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(26.055 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-115",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(52.11 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-116",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(72.033 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-117",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(96.044 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-118",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(120.055 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-119",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(144.065 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-120",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(168.077 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-121",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(192.087 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-122",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(216.098 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-123",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(240.109 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-124",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(260.032 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-125",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(286.086 5.38) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-126",
    "data-name": "Oval",
    cx: 2.69,
    cy: 3.006,
    rx: 2.69,
    ry: 3.006,
    transform: "translate(312.142 5.38) rotate(-90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f236822c10ce29f668e04780ceb07dda.svg";
export { ForwardRef as ReactComponent };